import React from 'react';
import {Button, Settings} from 'components';

export function MembershipUpgraded({ popup }) {
  return (
    <div>
      <h1>Congratulations!</h1>
      <p>Your account has been successfully upgraded to <span className="nowrap">the Premium plan.</span></p>
      <p>You now have full unlimited access to the complete web and mobile applications.</p>
      <Settings.MembershipAlert />
      <p className="medium-spacing text-right">
        <Button to="/settings/membership/" onClick={popup.close}>Ok</Button>
      </p>
    </div>
  );
}
